<template>
  <div
    class="rounded-lg bg-yellow-400 flex items-center flex-col md:flex-row justify-between p-3 shadow-lg"
  >
    <div class="flex flex-row items-center self-start">
      <div
        class="bg-yellow-700 rounded-lg w-10 h-10 flex items-center justify-center shrink-0"
      >
        <UIcon
          name="i-heroicons-megaphone"
          class="w-6 h-6 text-current text-white"
        />
      </div>
      <TText classes="mb-0 ml-3" variant="semibold" color="yellow900">
        {{ text }}
      </TText>
    </div>
    <div v-if="button" class="w-full md:w-auto mt-2 md:mt-0">
      <UButton
        color="gray"
        variant="solid"
        size="md"
        block
        :to="button.url ? button.url : undefined"
        external
        target="_blank"
        @click="emit('banner-click', $event)"
        >{{ button.text }}</UButton
      >
    </div>
  </div>
</template>
<script setup lang="ts">
const emit = defineEmits(['banner-click'])
interface PropsInterface {
  text: string
  button: {
    text: string
    url: string | null
  } | null
}
defineProps<PropsInterface>()
</script>
